/* Gallery cards.
   This script does TWO things and deliberately nothing else:
     1. scale each 1080 card down to the slide box it sits in,
     2. open the gallery on slide one.

   It does NOT move slides. Liquid already interleaves the cards at gallery
   positions 3, 5, 7 and 9, and koko-variant-media rebuilds the gallery from its
   own captured order, which keeps them there. An earlier version reordered the
   slides here as well, and the two rewrote the same list in a loop: the gallery
   flicked between a photograph and a card without ever settling. One owner per
   list. */
(function () {
  function fit(el) {
    var box = el.parentElement;
    if (!box) return;
    var w = box.clientWidth, h = box.clientHeight;
    if (!w || !h) return;
    var s = ((w < h ? w : h) / 1080).toFixed(5);
    /* Only write when the value really changed. Setting a style property fires
       a mutation record even when the value is identical, and anything watching
       this subtree would keep re-firing on our own write. */
    if (el.__kcS === s) return;
    el.__kcS = s;
    el.style.setProperty('--kc-s', s);
  }

  function fitAll() {
    document.querySelectorAll('.koko-card').forEach(function (el) {
      fit(el);
      if (!el.__kcRo && window.ResizeObserver && el.parentElement) {
        el.__kcRo = new ResizeObserver(function () { fit(el); });
        el.__kcRo.observe(el.parentElement);
      }
    });
  }

  /* The theme opens the gallery on the selected variant's own photograph, which
     on a phone case is the tenth slide, so every card sat behind the opening
     frame. The variant filter already hides the other colourways, so slide one
     is a photograph of the colour the shopper chose: opening there loses
     nothing and puts the cards back where they were designed to be.
     First load only. A colour change still moves the gallery as before. */
  function open() {
    var list = document.querySelector('.product__media-list');
    if (!list || list.__kcOpened) return;
    var viewer = list.closest('.product__media-gallery-viewer');
    var sw = viewer && viewer.swiper;
    if (!sw) return;
    if (!list.querySelector('.koko-card-slide')) return;
    list.__kcOpened = true;
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
      list.addEventListener(ev, function () { list.__kcTouched = true; }, { once: true, passive: true });
    });
    var go = function () {
      if (list.__kcTouched || sw.activeIndex === 0) return;
      try { sw.slideTo(0, 0, false); } catch (e) {}
    };
    go();
    setTimeout(go, 400);
    setTimeout(go, 1000);
  }

  function boot() {
    fitAll();
    open();
    [300, 900, 1800].forEach(function (ms) {
      setTimeout(function () { fitAll(); open(); }, ms);
    });
    /* childList only, and never attributes: Swiper rewrites style and class on
       every slide on every transition, so watching attributes here is a loop. */
    var host = document.querySelector('media-gallery');
    if (host && window.MutationObserver && !host.__kcMo) {
      var t;
      host.__kcMo = new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(fitAll, 250);
      });
      host.__kcMo.observe(host, { childList: true, subtree: true });
    }
    document.addEventListener('koko:media-filtered', function () {
      setTimeout(fitAll, 60);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', function () { setTimeout(function () { fitAll(); open(); }, 200); });
})();
